import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M14.666 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0M6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }